(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('wt-header-search')) {
    class WTHeaderSearch extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.input = this.querySelector('input[type="search"]');

        if (!this.details || !this.summary) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.details.addEventListener(
          'toggle',
          () => {
            if (this.details.open) {
              window.requestAnimationFrame(() => this.input?.focus());
            }
          },
          { signal }
        );

        document.addEventListener(
          'click',
          (event) => {
            if (this.details.open && !this.contains(event.target)) {
              this.details.open = false;
            }
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && this.details.open) {
              this.details.open = false;
              this.summary.focus();
            }
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    }

    customElements.define('wt-header-search', WTHeaderSearch);
  }

  if (!customElements.get('wt-header-root')) {
    class WTHeaderRoot extends HTMLElement {
      connectedCallback() {
        this.decorateMobileQuizLink();
      }

      normalizeUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return `${url.pathname.replace(/\/$/, '') || '/'}${url.search}`;
        } catch (_error) {
          return value;
        }
      }

      decorateMobileQuizLink() {
        const quizUrl = this.dataset.quizUrl;
        const quizText = this.dataset.quizText;
        if (!quizUrl || !quizText) return;

        const targetUrl = this.normalizeUrl(quizUrl);
        const links = Array.from(this.querySelectorAll('.menu-drawer a[href]'));
        let quizLink =
          links.find((link) => this.normalizeUrl(link.getAttribute('href')) === targetUrl) ||
          links.find((link) => link.textContent.trim().toLowerCase().includes('quiz'));

        if (this.dataset.showMobileQuiz !== 'true') {
          quizLink?.closest('li')?.remove();
          return;
        }

        if (!quizLink) {
          const menu = this.querySelector('.menu-drawer__menu');
          if (!menu) return;

          const item = document.createElement('li');
          item.className = 'wt-header-quiz-item';
          quizLink = document.createElement('a');
          quizLink.href = quizUrl;
          quizLink.className = 'menu-drawer__menu-item link link--text focus-inset';
          item.appendChild(quizLink);
          menu.appendChild(item);
        }

        quizLink.textContent = quizText;
        quizLink.classList.add('wt-header-quiz-button');
      }
    }

    customElements.define('wt-header-root', WTHeaderRoot);
  }

  } catch(e) { console.error(e); }
})();
})();
